var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TopNavigation',{attrs:{"activeApp":"Ops Portal Login"}}),_c('div',{staticClass:"auth"},[(!_vm.signedIn)?_c('sign-in'):_c('Home')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }